import { useFormikContext } from "formik";
import React from "react";

import {
  ProfessionalIncomeBusinessCode44ADA,
  ProfesssionalDetailsDropdown
} from "../../../../config/filingConstants";
import { IProfessionalIncomes } from "../../../../config/interfaces";
import { UtilService } from "../../../../services";
import PriceDisplay from "../../../PriceDisplay";
import { FormField, NumericInputField, SelectInputField, TextInputField } from "../../../fields";

const BPIRevenueLessThan75lakhsForm: React.FC = () => {
	const { values, errors, touched, setFieldValue, handleBlur } =
		useFormikContext<IProfessionalIncomes>();

	return (
		<section className="mb-5">
			<FormField label="Name of Business" isRequired={true} sm={4}>
				<SelectInputField
					placeholder="Business Name"
					name="BusinessName"
					isOptionArrayOfObject={false}
					options={ProfesssionalDetailsDropdown}
					value={[values.BusinessName]}
					onChange={(selectedbusinessName) => {
						if (selectedbusinessName) {
							setFieldValue("BusinessName", selectedbusinessName.value);
						} else {
							setFieldValue("BusinessName", undefined);
						}
					}}
					onBlur={handleBlur("BusinessName")}
					isInvalid={Boolean(errors.BusinessName) && touched.BusinessName}
					errorMsg={errors.BusinessName}
				/>
			</FormField>

			<FormField label="Business Code" isRequired={true} sm={4}>
				<SelectInputField
					placeholder="Business Code"
					name="BusinessCode"
					isSearchable={true}
					options={UtilService.convertToArray(ProfessionalIncomeBusinessCode44ADA)}
					value={{
						"label": ProfessionalIncomeBusinessCode44ADA[values.BusinessCode],
						"value": values.BusinessCode
					}}
					onChange={(selectedbusinessCode) => {
						if (selectedbusinessCode) {
							setFieldValue("BusinessCode", selectedbusinessCode.value);
						} else {
							setFieldValue("BusinessCode", undefined);
						}
					}}
					onBlur={handleBlur("BusinessCode")}
					isInvalid={Boolean(errors.BusinessCode) && touched.BusinessCode}
					errorMsg={errors.BusinessCode}
				/>
			</FormField>

			<FormField label="Description" sm={4}>
				<TextInputField
					name="Description"
					value={values.Description}
					onChange={(value) => setFieldValue("Description", value)}
					onBlur={(e) => {
						handleBlur(e);
						setFieldValue("Description", values.Description.trim());
					}}
					isInvalid={Boolean(errors.Description) && touched.Description}
					errorMsg={errors.Description}
				/>
			</FormField>
			<GrossReceiptsForm />
		</section>
	);
};

export default BPIRevenueLessThan75lakhsForm;

const GrossReceiptsForm: React.FC = () => {
	const { values, errors, touched, setFieldValue, handleBlur } =
		useFormikContext<IProfessionalIncomes>();

	const getNetIncome = (value1: string, value2: string, value3: string) => {
		const gainsValue = Number(value1 || 0) + Number(value2 || 0) + Number(value3 || 0);
		const TotalSection44ADA = 0.5 * gainsValue;

		setFieldValue("GrossReceipt", gainsValue);
		setFieldValue("TotalSection44ADA", TotalSection44ADA);
	};

	return (
		<>
			<div className="os-title-wrap">
				<h5 className="fw-bold">
					1. Gross Receipts
					<span className="info-wrap" role="button"></span>
				</h5>
				<p className="leading-para mb-0">
					<PriceDisplay price={values?.GrossReceipt || "0"} />
				</p>
			</div>
			<hr />

			<section>
				<FormField
					label="a. Through a/c payee cheque or a/c payee bank draft or bank electronic clearing system received or prescribed electronic modes"
					sm={6}
					isRequired={true}
				>
					<NumericInputField
						decimalUpto={0}
						showLeftIcon={true}
						name="ElectronicMode"
						value={values?.ElectronicMode || ""}
						onChange={(value) => {
							setFieldValue("ElectronicMode", value);
							getNetIncome(value, values.InCash, values.OtherMode);
						}}
						onBlur={handleBlur("ElectronicMode")}
						isInvalid={Boolean(errors.ElectronicMode) && touched.ElectronicMode}
						errorMsg={errors.ElectronicMode}
					/>
				</FormField>

				<FormField label="b. Receipts in cash" sm={6} isRequired={true}>
					<NumericInputField
						decimalUpto={0}
						showLeftIcon={true}
						name="InCash"
						value={values?.InCash || ""}
						onChange={(value) => {
							setFieldValue("InCash", value);
							getNetIncome(values.ElectronicMode, value, values.OtherMode);
						}}
						onBlur={handleBlur("InCash")}
						isInvalid={Boolean(errors.InCash) && touched.InCash}
						errorMsg={errors.InCash}
					/>
				</FormField>

				<FormField label="c. Any other mode other than a and b" sm={6} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						decimalUpto={0}
						name="OtherMode"
						value={values?.OtherMode || ""}
						onChange={(value) => {
							setFieldValue("OtherMode", value);
							getNetIncome(values.ElectronicMode, values.InCash, value);
						}}
						onBlur={handleBlur("OtherMode")}
						isInvalid={Boolean(errors.OtherMode) && touched.OtherMode}
						errorMsg={errors.OtherMode}
					/>
				</FormField>
			</section>

			<div className="os-title-wrap">
				<h5 className="fw-bold">
					2. Presumptive Income u/s 44ADA
					<span className="info-wrap" role="button"></span>
				</h5>
				<p className="leading-para mb-0">
					<PriceDisplay price={values.TotalSection44ADA || "0"} />
				</p>
			</div>
		</>
	);
};
